<template>
<div>
    <section>
        <b-field position="is-right">
            <b-input placeholder="Search..." type="search" icon="search" v-model="search">
            </b-input>
            <p class="control">
                <b-dropdown class="hover-rotate-90" hoverable aria-role="list" position="is-bottom-left" :disabled="toggleDelete">
                    <button class="button is-primary" slot="trigger">
                        <b-icon icon="plus" pack="fal"></b-icon>
                    </button>

                    <b-dropdown-item v-for="type in accommodationTypes" aria-role="listitem" @click="addAccommodation({name:type.default,type:type.name},true)">
                        <b-icon :icon="icon(type.name)" pack="fad"></b-icon> {{type.title}}
                    </b-dropdown-item>
                </b-dropdown>
            </p>
            <p class="control">
                <button class="button is-danger" @click="toggleDelete = !toggleDelete">
                    <b-icon icon="minus" pack="fal"></b-icon>
                </button>
            </p>
        </b-field>

    </section>
    <section>
        <Draggable :list="$root.event.accommodations" group="accommodations" :options="{handle:'.draggy'}">
            <div class="arrangement-cards">
                <div class="card is-grid" v-for="accommodation in filtered" :class="{ giggly: toggleDelete }">
                    <header class="card-header">
                        <p class="card-header-title">
                            <b-icon v-if="!toggleDelete" :icon="icon(accommodation.type)" pack="fad" :class="{ draggy: toggleDrag }" class="icon-fix"></b-icon>
                            <a v-else @click="removeAccommodation(accommodation)">
                                <b-icon icon="minus-circle" pack="fas" type="is-danger"></b-icon>
                            </a>
                            <span>{{accommodation.name}}</span>
                        </p>
                    </header>
                    <div class="card-content">
                        <div class="content">
                            <span v-if="accommodation.description">{{accommodation.description}}</span>
                        </div>
                    </div>
                    <footer class="card-footer">
                        <a class="card-footer-item" @click="editAccommodation(accommodation)">
                            <b-icon pack="fad" icon="edit" size="is-small"></b-icon>
                        </a>
                        <a class="card-footer-item" @click="addAccommodation(accommodation)" title="Duplizieren">
                            <b-icon pack="fad" icon="clone" size="is-small"></b-icon>
                        </a>

                    </footer>
                </div>
            </div>

        </Draggable>
    </section>
    <b-modal :active.sync="isCardModalActive" scroll="keep" @close="saveAccommodation()">
        <div class="card is-modal">
            <header class="card-header">
                <p class="card-header-title">
                    <b-icon :icon="icon(editableAccommodation.type)" pack="fad"></b-icon>&nbsp;&nbsp;{{editableAccommodation.name}}
                </p>
            </header>
            <div class="card-content">

                <div class="content">
                    <b-field horizontal label="Name"  class="field-grid">
                        <b-input v-model="editableAccommodation.name"></b-input>
                        <b-select v-model="editableAccommodation.type" placeholder="Bitte wählen Sie den Typ:" icon-pack="fad" :icon="icon(editableAccommodation.type)">
                            <option v-for="type in accommodationTypes" :value="type.name">
                                {{type.title}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field horizontal label="Ort/ Adresse">
                        <b-input maxlength="2000" v-model="editableAccommodation.accommodation" type="textarea"></b-input>
                    </b-field>
                    <b-field label="Beschreibung" horizontal>
                        <b-input maxlength="2000" v-model="editableAccommodation.description" type="textarea"></b-input>
                    </b-field>
                    <b-field label="Gruppe" horizontal  class="field-grid">
                        <b-select v-if="!tempGroup.active" v-model="editableAccommodation.group" expanded>
                            <option value="0" key="0">
                                keine Gruppe
                            </option>
                            <option v-for="option in $root.event.groups" :value="option.id" :key="option.id">
                                {{ option.name }}
                            </option>
                        </b-select>
                        <b-input v-else v-model="tempGroup.name" expanded></b-input>
                        <p class="control">
                            <button v-if="tempGroup.active" class="button is-success" @click="newGroup()">
                                <b-icon icon="save" pack="fad"></b-icon>
                            </button>
                            <button v-else class="button is-primary" @click="tempGroup.active = true">
                                <b-icon icon="plus" pack="fal"></b-icon>
                            </button>
                        </p>
                    </b-field>
                    <b-field label="CheckIn ab" horizontal >
                        <Timepicker placeholder="Bitte Auswählen..." v-model="editableAccommodation.checkin" :inline="true">
                        </Timepicker>
                    </b-field>
                    <b-field label="CheckOut bis" horizontal >
                        <Timepicker placeholder="Bitte Auswählen..." v-model="editableAccommodation.checkout" :inline="true">
                        </Timepicker>
                    </b-field>
                    <b-field label="Zimmerkontingent" horizontal>
                        <b-switch v-model="editableAccommodation.quotaExists">
                        </b-switch>
                        <b-numberinput icon-pack="fal" min="0" v-model="editableAccommodation.quota" v-if="editableAccommodation.quotaExists">
                        </b-numberinput>
                    </b-field>
                    <b-button type="is-success" @click="saveAccommodation()">Speichern</b-button>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
export default {
    name: 'Accommodations',
    components: {

    },
    props: {

    },
    data() {
        return {
            toggleDelete: false,
            toggleDrag: true,
            search: '',
            tempGroup: {
                active: false,
                name: '',
            },
            isCardModalActive: false,
            editableAccommodation: {},
            accommodationTypes: [{
                    title: 'Unterbringung',
                    icon: 'hotel',
                    name: 'main',
                    default: 'neue Unterbringung'
                },
                {
                    title: 'Einzelzimmer',
                    icon: 'user',
                    name: 'single',
                    default: 'neues Einzelzimmer'
                },
                {
                    title: 'Doppelzimmer',
                    icon: 'user-friends',
                    name: 'double',
                    default: 'neues Doppelzimmer'
                }
            ]
        }
    },
    methods: {
        update(id = this.$route.params.id) {
            return true
        },
        saveEvent() {
            this.$root.saveEvent(this.$route.params.id)
        },
        newGroup() {
            let group = {}
            group.id = ++this.$root.event.counter.groups
            group.name = this.tempGroup.name
            if(typeof this.$root.event.groups != 'array' && typeof this.$root.event.groups != 'object') this.$root.event.groups = []
            this.$root.event.groups.push(group)
            if(this.editableAccommodation) {
                this.editableAccommodation.group = group.id
            }
            this.tempGroup.name = ''
            this.tempGroup.active = false
            this.saveEvent()
        },
        addAccommodation(template = {}, init = false) {
            let accommodation = {}
            accommodation = Object.assign(accommodation, template)
            accommodation.id = ++this.$root.event.counter.accommodations
            if (!accommodation.name) {
                accommodation.name = 'Neue Unterbringung'
            } else if (!init) {
                accommodation.name += ' Kopie'
            }
            if (!accommodation.type) {
                accommodation.type = 'misc'
            }
            if(!this.$root.event.accommodations){
                this.$root.event.accommodations = []
            }
            this.$root.event.accommodations.push(accommodation)
            this.saveEvent()
        },
        editAccommodation(accommodation) {
            this.isCardModalActive = true
            this.editableAccommodation = accommodation

        },
        saveAccommodation() {
            this.isCardModalActive = false
            this.$root.saveEvent(this.$route.params.id, true)
        },
        icon(type = 'main') {
            let find = this.accommodationTypes.find(function (element) {
                return element.name == type
            })
            return find.icon
        },
        removeAccommodation(old) {
            this.$buefy.dialog.confirm({
                title: 'Unterbringung löschen?',
                message: 'Sind Sie sicher, dass Sie die <br>Unterbringung <b><i>' + old.name + '</i> löschen</b> möchten?<br>Diese Aktion kann nicht Rückgängig gemacht werden.',
                confirmText: 'Unterbringung löschen',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    let wksps = []
                    this.$root.event.accommodations.forEach(function (element) {
                        if (element.id !== old.id) {
                            wksps.push(element)
                        }
                    });
                    this.$root.event.accommodations = wksps
                    this.saveEvent()
                    this.$buefy.toast.open({
                        message: 'Die Unterbringung <b>' + old.name + '</b> wurde gelöscht',
                        type: 'is-success'
                    })
                }
            })
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed

        this.update()
    },
    computed: {
        filtered() {
            var origin = this.$root.event.accommodations,
                filtered = [],
                patt = new RegExp(this.search, "i");
            this.toggleDrag = true
            if (this.search == '') {
                return origin
            }
            if (this.search.length < 3) {
                return origin
            }
            this.toggleDrag = false
            origin.forEach(entry => {
                if (patt.test(entry.name)) {
                    filtered.push(entry)
                    return
                }
            })
            return filtered
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.c-preview {
    width: 50px;
}

.hover-rotate-90 .dropdown-trigger .icon i {
    transition: transform .8s ease;
}

.hover-rotate-90.is-active .dropdown-trigger .icon i,
.hover-rotate-90:hover .dropdown-trigger .icon i {
    transform: rotate(90deg);
}

.card.is-grid {
    display: inline-block;
    width: 250px;
    margin: 20px;
    vertical-align: top;
}

.card.is-modal {
    min-width: 270px;
    margin: 20px;
}

.event-list {
    text-align: center;
}

.giggly {
    transition: transform .05s ease;
    animation-name: giggle;
    animation-duration: .2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes giggle {
    0% {
        transform: rotate(0deg);
    }

    25% {
        transform: rotate(-1deg);
    }

    50% {
        transform: rotate(0deg);
    }

    75% {
        transform: rotate(1deg);
    }

    1000% {
        transform: rotate(0deg);
    }
}
</style>
